import { useMemo } from 'react';

import { getRandomHash } from '@utils';

const useRandomElementId = (prefix?: string) => {
  return useMemo(() => getRandomHash(prefix), []);
};

export default useRandomElementId;
